import React, {  ReactNode } from "react";
import { createGenericModalContext } from "../../../../../components/BasicComponents/GenericModalContext";
import DialogDetalheSolicitacao from "./DialogDetalheSolicitacao";

const { GenericModalProvider, useGenericModal } = createGenericModalContext<string>();

export const ModalDetalheSolicitacaoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
   return (
           <GenericModalProvider
               ModalComponent={DialogDetalheSolicitacao}
               urlParam="detalhe-solicitacao"
           >
               {children}
           </GenericModalProvider>
       );
};

export const useModalDetalheSolicitacao = useGenericModal;